import React, { useEffect, useState } from "react";

export function useViewType() {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 640);
  
    useEffect(() => {
      const handleResize = () => {
        setIsDesktop(window.innerWidth >= 640);
      };

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    return isDesktop;
  }